import(/* webpackMode: "eager" */ "/root/StudyAbroad/client/src/app/layout.tsx");
